<app-section-header title="{{ 'workOrderMaterials.material' | translate }}"></app-section-header>
<!-- Column headers -->
<div class="table-header">
  <div class="col-article">{{ 'workOrderMaterials.articleNumber' | translate }}</div>
  <div class="col-description">{{ 'workOrderMaterials.description' | translate }}</div>
  <div class="col-qty">{{ 'workOrderMaterials.quantity' | translate }}</div>
</div>

<!-- Per-field filter row -->
@if (materials && materials.length > 0) {
  <div class="filter-row" role="search">
    <div class="col-article filter-col">
      <div class="filter-chip filter-article">
        <svg class="filter-icon" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false">
          <path
            fill="currentColor"
            d="M15.5 14h-.79l-.28-.27A6.47 6.47 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
          />
        </svg>
        <input
          type="text"
          class="filter-input"
          [(ngModel)]="filters.articleNumber"
          (ngModelChange)="applyFilters()"
          placeholder="{{ 'workOrderMaterials.articleNumber' | translate }}"
          attr.aria-label="{{ 'workOrderMaterials.articleNumber' | translate }}"
        />
        @if (filters.articleNumber) {
          <button
            type="button"
            class="filter-clear"
            attr.aria-label="{{ 'workOrderMaterials.filters.clear' | translate }}"
            (click)="clearFilter('articleNumber')"
          >
            <mat-icon>close</mat-icon>
          </button>
        }
      </div>
    </div>

    <div class="col-description filter-col filter-col-group">
      <div class="filter-chip filter-description">
        <svg class="filter-icon" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false">
          <path
            fill="currentColor"
            d="M15.5 14h-.79l-.28-.27A6.47 6.47 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
          />
        </svg>
        <input
          type="text"
          class="filter-input"
          [(ngModel)]="filters.description"
          (ngModelChange)="applyFilters()"
          placeholder="{{ 'workOrderMaterials.description' | translate }}"
          attr.aria-label="{{ 'workOrderMaterials.description' | translate }}"
        />
        @if (filters.description) {
          <button
            type="button"
            class="filter-clear"
            attr.aria-label="{{ 'workOrderMaterials.filters.clear' | translate }}"
            (click)="clearFilter('description')"
          >
            <mat-icon>close</mat-icon>
          </button>
        }
      </div>

      <div class="filter-chip filter-status">
        <svg class="filter-icon" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false">
          <path
            fill="currentColor"
            d="M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"
          />
        </svg>
        <select
          class="filter-select"
          [(ngModel)]="filters.status"
          (ngModelChange)="applyFilters()"
          attr.aria-label="{{ 'workOrderMaterials.materialStatus' | translate }}"
        >
          <option value="">{{ 'workOrderMaterials.filters.all' | translate }}</option>
          @for (status of statusOptions; track status) {
            <option [value]="status">{{ status }}</option>
          }
        </select>
        <mat-icon class="filter-select-arrow">arrow_drop_down</mat-icon>
      </div>

      <div class="filter-chip filter-location">
        <svg class="filter-icon" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false">
          <path
            fill="currentColor"
            d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5z"
          />
        </svg>
        <input
          type="text"
          class="filter-input"
          [(ngModel)]="filters.location"
          (ngModelChange)="applyFilters()"
          placeholder="{{ 'workOrderMaterials.location' | translate }}"
          attr.aria-label="{{ 'workOrderMaterials.location' | translate }}"
        />
        @if (filters.location) {
          <button
            type="button"
            class="filter-clear"
            attr.aria-label="{{ 'workOrderMaterials.filters.clear' | translate }}"
            (click)="clearFilter('location')"
          >
            <mat-icon>close</mat-icon>
          </button>
        }
      </div>
    </div>

    <div class="col-qty"></div>

    @if (hasActiveFilters()) {
      <button
        class="filter-clear-all"
        type="button"
        (click)="clearFilters()"
        attr.aria-label="{{ 'workOrderMaterials.filters.clearAll' | translate }}"
        title="{{ 'workOrderMaterials.filters.clearAll' | translate }}"
      >
        <mat-icon>filter_alt_off</mat-icon>
      </button>
    }
  </div>
}

@for (group of filteredGroups; track group.materialNumber) {
  <div class="material-group">
    <!-- ── Group header row (long-press opens comment panel) ── -->
    <app-comment-panel
      [id]="group.materialNumber"
      [referenceId]="group.materialNumber"
      [referenceName]="group.materialNumber"
      referenceType="MATERIAL"
    >
      <div class="material-row material-header-row">
        <div class="col-article">{{ group.materialNumber }}</div>
        <div class="col-description">{{ group.description }}</div>
        <div class="col-qty">
          <span class="numeric-value">{{ group.quantity }}</span>
          <span class="material-unit">{{ group.unit }}</span>
        </div>
      </div>
    </app-comment-panel>

    <!-- ── Child lines — always expanded, show only what differs ── -->
    <div class="group-details">
      @for (material of group.items; track material.materialId) {
        <div class="material-row detail-row">
          <!-- Line index badge -->
          <div class="col-article detail-index">
            <span class="line-index">{{ $index + 1 }}</span>
          </div>

          <!-- Status + Location chips -->
          <div class="col-description detail-meta">
            <span class="detail-chip status-chip">
              {{ 'workOrderMaterials.materialStatus' | translate }}:
              {{ material.materialStatus || '-' }}
            </span>
            <span class="detail-chip location-chip">
              {{ 'workOrderMaterials.location' | translate }}:
              {{
                (material.locationNo || '') +
                  (material.locationNo && material.locationName ? ' – ' : '') +
                  (material.locationName || '') || '-'
              }}
            </span>
          </div>

          <!-- Individual quantity -->
          <div class="col-qty">
            <span class="numeric-value">{{ material.quantity }}</span>
            <span class="material-unit">{{ material.unit }}</span>
          </div>
        </div>
      }
    </div>
  </div>
}
@if (!materials || materials.length === 0) {
  <app-empty-list
    title="{{ 'workOrderMaterials.empty.title' | translate }}"
    info="{{ 'workOrderMaterials.empty.info' | translate }}"
  ></app-empty-list>
} @else if (filteredGroups.length === 0) {
  <app-empty-list
    icon="filter_alt_off"
    title="{{ 'workOrderMaterials.filters.noResultsTitle' | translate }}"
    info="{{ 'workOrderMaterials.filters.noResultsInfo' | translate }}"
  ></app-empty-list>
}
